module.exports = __webpack_public_path__ + "static/media/security.c32fc1fe.svg";